<script>
    // core components
    import DocumentoView from "../../viewsERP/Documento.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <DocumentoView />
    </div>
</div>
